(function($){

	$( document ).ready(function() {

        let images = [];
        $('.product-thumb').each(function(){
            images.push({
                src: $(this).data('src-full'),
                thumbSrc: $(this).data('src-thumb'),
                caption: $(this).attr('alt'),
            });
        });

        let zoomLink = $("#zoomTrigger");
        if (zoomLink.length && images.length) {
            zoomLink.on('click', function(){

                Fancybox.show(images, {
                    // Your custom options
                });
            })
        }

    });

})(jQuery);